module.exports = __webpack_public_path__ + "static/media/radiation-energy.6f8e0487.svg";